import axios from './AxiosService';

export default class ConfiguracionService {
  async get() {
    return await axios.get('/configuracion').then(result => result.data);
  }
}